module.exports = __webpack_public_path__ + "fonts/triya-icon.949311c.ttf";